module.exports = __webpack_public_path__ + "static/media/teonPhoneLigth.b5d62461.png";